module.exports = __webpack_public_path__ + "static/media/Icon_pan.267ca13e.svg";